import type { SVGProps } from 'react';

const SvgCalendarLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M7.5 2V5.5M16.5 2V5.5M4 8.4H20M5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20Z'
      stroke='currentColor'
      strokeLinecap='round'
    />
    <path
      d='M12 13.5C11.45 13.5 11 13.05 11 12.5C11 11.95 11.45 11.5 12 11.5C12.55 11.5 13 11.95 13 12.5C13 13.05 12.55 13.5 12 13.5Z'
      fill='currentColor'
    />
    <path
      d='M12 17C11.45 17 11 16.55 11 16C11 15.45 11.45 15 12 15C12.55 15 13 15.45 13 16C13 16.55 12.55 17 12 17Z'
      fill='currentColor'
    />
    <path
      d='M8 17C7.45 17 7 16.55 7 16C7 15.45 7.45 15 8 15C8.55 15 9 15.45 9 16C9 16.55 8.55 17 8 17Z'
      fill='currentColor'
    />
    <path
      d='M16 13.5C15.45 13.5 15 13.05 15 12.5C15 11.95 15.45 11.5 16 11.5C16.55 11.5 17 11.95 17 12.5C17 13.05 16.55 13.5 16 13.5Z'
      fill='currentColor'
    />
    <path
      d='M16 17C15.45 17 15 16.55 15 16C15 15.45 15.45 15 16 15C16.55 15 17 15.45 17 16C17 16.55 16.55 17 16 17Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgCalendarLt;
